import { Box as MuiBox, BoxProps } from '@mui/material';

const Box = ({ children, ...rest }: BoxProps) => (
	<MuiBox {...rest}>{children}</MuiBox>
);

export default Box;
